import { exists } from '@/api'

export interface SeparateDictionary {
  id: number
  name: string
  separateName: string
  revision: number
}

export const defaultSeparateDictionary = (): SeparateDictionary => ({
  id: 0,
  name: '',
  separateName: '',
  revision: 0
})

export function SeparateDictionaryFromJSON(json: any): SeparateDictionary {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    separateName: exists(json, 'separate_name') ? json.separate_name : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
